<template>
  <div>
    <v-btn flat large color="orange" @click.stop="dialog = true">Share</v-btn>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          <span class="title">Share it with others</span>
        </v-card-title>
        <v-card-text text-xs-center>
          <vue-goodshare-facebook
            :page-url="page_url"
            title_social="Facebook"
            has_icon
          >
          </vue-goodshare-facebook>
          <vue-goodshare-twitter
            :page-url="page_url"
            title_social="Twitter"
            has_icon
          ></vue-goodshare-twitter>
          <vue-goodshare-linked-in
            :page-url="page_url"
            title_social="LinkedIn"
            has_icon
          ></vue-goodshare-linked-in>
          <vue-goodshare-pinterest
            :page-url="page_url"
            title_social="Pinterest"
            has_icon
          ></vue-goodshare-pinterest>
          <vue-goodshare-email
            :page-url="page_url"
            title_social="Email"
            has_icon
          ></vue-goodshare-email>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue';
import VueGoodshareLinkedIn from 'vue-goodshare/src/providers/LinkedIn.vue';
import VueGoodsharePinterest from 'vue-goodshare/src/providers/Pinterest.vue';
import VueGoodshareEmail from 'vue-goodshare/src/providers/Email.vue';

export default {
  name: 'AppSocialShare',
  components: {
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareLinkedIn,
    VueGoodsharePinterest,
    VueGoodshareEmail,
  },
  data() {
    return {
      page_url: window.location.href,
      dialog: false,
    };
  },
};
</script>
